
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`When to use attrs?`}</h2>
    <p>{`You can pass in attributes to styled components using `}<a parentName="p" {...{
        "href": "/docs/basics#attaching-additional-props"
      }}>{`attrs`}</a>{`, but it is not always sensible to do so.`}</p>
    <p>{`The rule of thumb is to use `}<inlineCode parentName="p">{`attrs`}</inlineCode>{` when you want every instance of a styled component to have that prop, and `}<a parentName="p" {...{
        "href": "/docs/basics#passed-props"
      }}>{`pass props`}</a>{` directly when every instance needs a different one:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const PasswordInput = styled.input.attrs(props => ({
  // Every <PasswordInput /> should be type="password"
  type: "password"
}))\`\`

// This specific one is hidden, so let's set aria-hidden
<PasswordInput aria-hidden="true" />
`}</code></pre>
    <p>{`The same goes for props that can be inferred based on the "mode" of another prop. In this case you can set a property on `}<inlineCode parentName="p">{`attrs`}</inlineCode>{` to a function that computes that prop based on other props.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;